import React, { FC } from 'react';
import { IOuter } from './GalleryLayout.types';
import { map } from 'ramda';
import styles from './GalleryLayout.scss';
import { GalleryItem } from '../GalleryItem';

export const GalleryLayout: FC<IOuter> = ({
  items,
  isItemSelected,
  isItemDisabled,
  onItemClick,
  onItemDoubleClick,
}) => (
  <ul className={styles.wrapper}>
    {map(
      (item) => (
        <GalleryItem
          key={item.id}
          item={item}
          isItemSelected={isItemSelected}
          onItemClick={onItemClick}
          onItemDoubleClick={onItemDoubleClick}
          isItemDisabled={isItemDisabled}
        />
      ),
      items,
    )}
  </ul>
);
